// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3p9XE","signatureButtonsRight":"ModalSign_signatureButtonsRight__MaVu7"};